module.exports = __webpack_public_path__ + "static/img/banner7.97bef00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner7.png
// module id = zAwF
// module chunks = 1